import { pick } from "lodash-es"
import React from "react"
import RowSelector, {
  RowSelectorAll,
  RowSelectorColumn,
} from "components/Molecules/RowSelector"
import CustomReactTable from "components/Templates/CustomReactTable"
import { useDispatchList } from "graphql/dms/dms.hooks.gql"
import dayjs from "dayjs"
import StyledLink from "components/Atoms/StyledLink"

const DMSTable = () => {
  const { data, loading } = useDispatchList()
  const disptaches = data?.tripsForDate || []

  const COLUMNS = [
    {
      ...RowSelectorColumn,
      accessor: "id",
      Header({ data }) {
        return (
          <RowSelectorAll
            path="dms"
            payload={data?.map(({ _original }) => pick(_original, ["id"]))}
          />
        )
      },
      Cell({ original }) {
        return <RowSelector path="dms" payload={pick(original, ["id"])} />
      },
    },
    {
      Header: "Gate Pass No.",
      accessor: "uuid",
      Cell({ value }) {
        return <div className="vt-text-center">{value.split("-")[0]}</div>
      },
    },
    {
      Header: "Dispatch status",
      accessor: "despatchStatus",
      Cell({ value }) {
        let status = ""
        switch (value) {
          case "DSP":
            status = "Despatch Planned"
            break
          case "DKA":
            status = "Dock Assigned"
            break
          case "PEN":
            status = "Premises Entered"
            break
          case "DET":
            status = "Dock Entered"
            break
          case "LOD":
            status = "Loading"
            break
          case "PEX":
            status = "Premises Exited"
            break
          case "NOD":
            status = "Not Defined"
            break
          default:
            break
        }
        return <div className="vt-text-center">{status}</div>
      },
    },
    {
      minWidth: 100,
      Header: "Arrange as per",
      accessor: "loadingPattern",
      Cell({ value, original }) {
        const asPer =
          value === "ORD"
            ? "Per Order"
            : value === "SLI"
            ? "Per Items"
            : "Not Selected"
        return (
          <>
            <div className="vt-text-center">{asPer}</div>
          </>
        )
      },
    },
    {
      Header: "Vehicle number",
      accessor: "vehicle.registrationNumber",
      Cell({ value, original }) {
        return (
          <>
            <StyledLink
              to={`/d/ecom/dms/trip/${original.id}?loadingPattern=${original?.loadingPattern}`}
              className="vt-text-center"
            >
              {value}
            </StyledLink>
          </>
        )
      },
    },
    {
      Header: "Driver name",
      accessor: "aggregator.fullName",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Source time",
      accessor: "estimatedStartTime",
      Cell({ value, original }) {
        return (
          <div className="vt-text-center">
            {dayjs(new Date(value)).format("h:mm a")}
          </div>
        )
      },
    },
    {
      Header: "Dock number",
      accessor: "dock.name",
      Cell({ original, value }) {
        return <div className="vt-text-center">{value}</div>
      },
    },
    {
      Header: "Supervisor",
      accessor: "dockSupervisor.fullName",
      Cell({ original, value }) {
        return <div className="vt-text-center">{value}</div>
      },
    },

    {
      Header: "Status",
      accessor: "orderItems.0.shipping.estimatedDelivery",
      Cell({ value }) {
        let status = "On Trip"
        switch (value) {
          case "OT":
            status = "On Trip"
            break
          case "CP":
            status = "Completed"
            break
          case "DS":
            status = "Discarded"
            break
          case "NS":
            status = "Not Started"
            break
          case "PS":
            status = "Paused"
            break
          case "IL":
            status = "Idle"
            break
          case "ST":
            status = "Settled"
            break
          default:
            status = "On Trip"
        }
        return <div className="vt-text-center">{status}</div>
      },
    },
  ]

  return (
    <CustomReactTable
      getTrProps={(_, row) => {
        const status = row?.original?.loadingPattern

        if (status === "ORD") {
          return {
            className: "vt-order-confirmed",
          }
        } else if (status === "SLI") {
          return {
            className: "vt-order-completed",
          }
        } else {
          return {
            className: "vt-order-processing",
          }
        }
      }}
      pageSize={disptaches?.length > 15 ? disptaches?.length : 15}
      loading={loading}
      data={disptaches}
      columns={COLUMNS}
    />
  )
}

export default DMSTable
